const LOG_PREFIX = "[SAAP]";

const Logger = {
  enabled: false,

  log(...args) {
    if (!Logger.enabled) return;
    console.log(LOG_PREFIX, ...args);
  },

  info(...args) {
    if (!Logger.enabled) return;
    console.info(LOG_PREFIX, ...args);
  },

  warn(...args) {
    if (!Logger.enabled) return;
    console.warn(LOG_PREFIX, ...args);
  },

  error(...args) {
    if (!Logger.enabled) return;
    console.error(LOG_PREFIX, ...args);
  },

  debug(...args) {
    if (!Logger.enabled) return;
    console.debug(LOG_PREFIX, ...args);
  },
};

export default Logger;
